import React from 'react';
function PlanIngredient({
    ingredient,
    handlePair
}) {
    ingredient = {
        ...ingredient,
        Ingredient_Date:new Date(ingredient.Ingredient_Date)
    }
    var dateString = "??/??/????";
    if (ingredient.Ingredient_Date.valueOf()) {
        dateString = ingredient.Ingredient_Date.toLocaleDateString("en-UK",
            {
                weekday: "long",
                day: "numeric",
                month: "numeric",
                year: "numeric"
            }
        );
    }

    var frozenDate = "";
    if (isNaN(ingredient.Ingredient_Frozen) === false) {
        frozenDate = ingredient.Ingredient_Frozen.toLocaleDateString("en-UK",
            {
                weekday: "long",
                day: "numeric",
                month: "numeric",
                year: "numeric"
            }
        );
    }

    var quantityString = "??g";
    if (ingredient.Ingredient_Quantity > 0) {
        quantityString = ingredient.Ingredient_Quantity + "g";
    }

    var styleString = "ingredient-element list-element hoverable-element";
    if (frozenDate !== "")
        styleString += " frozen";
    else if ((ingredient.Ingredient_Date.valueOf() - 86400000) < new Date().valueOf()) {
        styleString += " danger";
    }

    function handleClick(e) {
        e.preventDefault();

        handlePair(ingredient)
    }

    function getPlanDate() {
        return new Date(ingredient.Plan_Date).toLocaleDateString("en-UK",
            {
                weekday: "long",
                day: "numeric",
                month: "numeric",
                year: "numeric"
            }
        )
    }

    return (
        <li className={styleString}>
            <div className="ing-data-container container">
                <p>{ingredient.Ingredient_Name}: {quantityString}</p>
                <p>{"Eat By: " + dateString}</p>
                {!ingredient.Plan_ID ? //if it doesn't have a plan id
                    (<button onClick={handleClick}>Use This Ingredient</button>) ://give option to use the ingredient
                    (<p>Being used in : {ingredient.Recipe_Name}<br/> on {getPlanDate()}</p>)
                }
            </div>
        </li>
    );
}

export default PlanIngredient;